export default "__VITE_ASSET__CLqVnHVX__"